import { Component, OnInit } from '@angular/core';
import { ChildQuery, ChildService } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, Observable, zip } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { UpgradeChildrenComponent } from '../upgrade-children/upgrade-children.component';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-child-list',
  templateUrl: 'child-list.component.html',
  styleUrls: ['child-list.component.scss'],
})
export class ChildListComponent implements OnInit {
  children$: Observable<any>;

  customOptions: OwlOptions = {
    margin: OwlCarouselSettings.Margin,
    autoWidth: true,
    pullDrag: false,
    nav: false,
    responsive: {
      0: { items: 1.2 },
      900: { items: 3 },
    },
  };
  loaded$: Observable<boolean>;

  constructor(
    private childQuery: ChildQuery,
    private childService: ChildService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    firstValueFrom(zip([this.childService.fetchChildren(), this.childService.fetchChildCountLimit()]));

    this.children$ = this.childQuery.getChildrenInfo();
    this.loaded$ = this.childQuery.isLoaded$;
  }

  upgradeChildren() {
    this.modalService.open(UpgradeChildrenComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'upgrade-children-modal',
      size: 'lg',
    });
  }
}
